import React, { useEffect, useState } from "react";
import { Link as RouterLink, useParams, useNavigate } from 'react-router-dom';
import {
  Container,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Switch,
  Modal,
  Box,
  Button,
  Typography,
  Stack,
  SelectChangeEvent,
  useTheme,
  useMediaQuery,
  Tooltip
} from "@mui/material";
import { useCancelBookingMutation, useGetAllBookingDetailBySearchCriteriaMutation } from "../../../redux/services/bookingApi";
import { useAppDispatch, useAppSelector } from "../../../redux/app/hooks";
import { getBookingDetails, getTotalPage, getTotalRecord, setBookingDetail } from "../../../redux/slices/bookingSlice";
import { formatDateTime } from "../../../redux/services/utility";
import { FaTrash } from "react-icons/fa";
import Iconify from "../../../components/Iconify";
import { useGetEnumDataMutation } from "../../../redux/services/enumApi";
import { getSpecificEnumData, setEnumData } from "../../../redux/slices/enumSlice";
import MuiAlert from "../../MuiAlert/MuiAlert";
import { useDownloadInvoiceMutation } from "../../../redux/services/downloadInvoiceApi";
import Loading from "../../commons/Loading";
import BookingCard from "./BookingCard";
import { BiChevronLeft, BiChevronRight } from "react-icons/bi";
import clearIcon from "../../../assets/Cancel.png";

const BookingTable = () => {
  const navigate = useNavigate();
  const dispatch: any = useAppDispatch();
  const [filter, setFilter] = useState<string>("CUSTOMER_UPCOMING_BOOKING");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [sortOrder, setSortOrder] = useState("ASC");
  const [
    getAllBookingDetailBySearchCriteria,
    getAllBookingDetailBySearchCriteriaResponse,
  ] = useGetAllBookingDetailBySearchCriteriaMutation();
  const [openModal, setOpenModal] = useState(false);
  const [currentBooking, setCurrentBooking] = useState<any>(null);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
  const token: string = currentUser?.jwtToken;
  const customerId: any = currentUser?.customerId;
  const getBookingData = useAppSelector(getBookingDetails)
  const [booking, setBooking] = useState([]) as any;
  const bookingTotalRecords = useAppSelector(getTotalRecord);
  const bookingTotalPage = useAppSelector(getTotalPage);

  const [selectedBooking, setSelectedBooking] = useState() as any;
  const [cancellationReasoning, setCancellationReasoning] = useState([]);
  const [getEnumData, enumResponse] = useGetEnumDataMutation();
  let enumData: any = useAppSelector(getSpecificEnumData);
  const [option, setOption] = useState("");
  const [cancelBooking, cancelBookingResponse] = useCancelBookingMutation();
  const [statusCode, setStatusCode] = useState({ type: "", code: "" }) as any;
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [downloadInvoice, downloadInvoiceResponse] = useDownloadInvoiceMutation();
  const [isCancelBookingLoading, setIsCancelBookingLoading] = useState(false);
  const [isDownloadInvoiceLoading, setIsDownloadInvoiceLoading] = useState(false);
  const [loadingBookingId, setLoadingBookingId] = useState<string | null>(null);
  console.log(loadingBookingId ,"loadingBookingId");
const [cancelBookingId, setCancelBookingId] = useState<string | null>(null);
console.log(cancelBookingId ,"loadingBookingId");

  useEffect(() => {
    if (enumData) {
      setCancellationReasoning(enumData["CANCELLATION_REASON"]);
    }
  }, [enumData]);

  useEffect(() => {
    getEnumData({ token: token });
  }, [token]);

  useEffect(() => {
    if (enumResponse.isSuccess) {
      dispatch(setEnumData(enumResponse.data));
    }
  }, [enumResponse.isSuccess]);

  useEffect(() => {
    if (token) {
      getAllBookingDetailBySearchCriteriaAsync(
        rowsPerPage,
        page,
        sortOrder,
        filter,
      );
    }
  }, [token, rowsPerPage, filter, page, sortOrder]);



  const getAllBookingDetailBySearchCriteriaAsync = async (
    reqOffset: number,
    reqPage: number,
    reqOrderBy: string,
    reqFlag?: string
  ) => {
    await getAllBookingDetailBySearchCriteria({
      token: token,
      payload: {
        offset: reqOffset,
        page: reqPage,
        orderBy: reqOrderBy,
        flag: reqFlag,
        customerId: customerId,
      },
    });
  };

  const handleLoadMore = (dataFlag: string) => {
    setPage(page + 1);
    handleChangePage(rowsPerPage, page + 1);
  };
  const handleLoadMores = (dataFlag: string) => {
    setPage(page - 1);
    handleChangePage(rowsPerPage, page - 1);
  };

  useEffect(() => {
    if (getAllBookingDetailBySearchCriteriaResponse.isSuccess) {
      dispatch(
        setBookingDetail(getAllBookingDetailBySearchCriteriaResponse.data)
      );
    }
  }, [getAllBookingDetailBySearchCriteriaResponse.isSuccess]);


  useEffect(() => {
    if (getBookingData) {
      setBooking(getBookingData);
    }
  }, [getBookingData]);

  const handleChangePage = async (event: any, newPage: any) => {
    setPage(newPage);
    getAllBookingDetailBySearchCriteriaAsync(
      rowsPerPage,
      newPage,
      sortOrder,
      filter,
    );
  };

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value));
    getAllBookingDetailBySearchCriteriaAsync(
      rowsPerPage,
      event.target.value,
      sortOrder,
      filter,
    );
  };

  const handleFilterChange = (event: SelectChangeEvent<string>) => {
    setFilter(event.target.value);
  };

  const handleOpenModal = (booking: any) => {
    setSelectedBooking(booking.id)
    setCurrentBooking(booking);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setCurrentBooking(null);
    cancelBookingDetail()

  };




  useEffect(() => {
    if (cancelBookingResponse.isSuccess) {
      setStatusCode({ type: "success", code: "CANCELLATION_SUCCESS" });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
      getAllBookingDetailBySearchCriteriaAsync(
        rowsPerPage,
        page,
        sortOrder,
        filter,
      );
    }
    if (cancelBookingResponse.error) {
      console.log(cancelBookingResponse.error, "cancelBookingResponse")
      setStatusCode({ type: "error", code: "CANCELLATION_ERROR" });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    }
  }, [cancelBookingResponse.isSuccess]);



  const cancelBookingDetail = async () => {
    if (!selectedBooking) return;
  
    setCancelBookingId(selectedBooking);
    try {
      await cancelBooking({
        bookingId: selectedBooking,
        cancellationReason: option,
        token: token,
      }).unwrap();
    } catch (error) {
      console.error("Error canceling booking:", error);
    } finally {
      setCancelBookingId(null);
    }
  };
  

  const handleDownloadInvoice = async (bookingSuccessData: any) => {
    setLoadingBookingId(bookingSuccessData.id);
    try {
      await downloadInvoice({
        token,
        bookingId: bookingSuccessData.id,
      }).unwrap();
    } catch (error) {
      console.error("Error downloading invoice:", error);
    } finally {
      setLoadingBookingId(null);
    }
  };
  

  return (
    <div className="rounded-xl  m-[5px] md:m-[10px] md:mx-8 mx-2 p-[5px] md:p-[8px] bg-white">
      {isAlertVisible && (
        <div>
          <MuiAlert
            severity={statusCode?.type!}
            messageType={statusCode?.code!}
          />
        </div>
      )}
      {getAllBookingDetailBySearchCriteriaResponse.isLoading ? (
        <Loading />
      ) : null}

      <div className="flex md:flex-row flex-col md:justify-between md:items-center items-start mb-3">
        <p className="text-[#434343] font-bold lg:text-[24px] md:text-[20px] text-[18px] md:mb-[20px] mb-[8px] ml-6">
          My Bookings
        </p>
        <FormControl fullWidth variant="outlined" className="max-w-[200px] md:mt-20 mt-8 justify-end">
          <InputLabel>Status</InputLabel>
          <Select
            value={filter}
            onChange={handleFilterChange}
            label="Status"
            className="text-gray-800"
          >
            <MenuItem value="CUSTOMER_UPCOMING_BOOKING">Upcoming</MenuItem>
            <MenuItem value="CUSTOMER_COMPLETED_BOOKING">Completed</MenuItem>
            <MenuItem value="CUSTOMER_CANCEL_BOOKING">Cancelled</MenuItem>
          </Select>
        </FormControl>
      </div>
      {booking.length > 0 ?
        <div className="w-full flex flex-wrap  justify-center md:p-4 p-1 md:gap-4 gap-2">
          {booking.map((booking: any) => (
            <div className="w-full">
              <BookingCard
                filter={filter}
                // flag={booking?.bookingStatus}
                isDownloadInvoiceLoading={loadingBookingId === booking.id}
                isCancelBookingLoading={cancelBookingId === booking.id}
                booking={booking}
                handleOpenModal={handleOpenModal}
                handleDownloadInvoice={handleDownloadInvoice}
              />
            </div>
          ))}
        </div>
        :
        <div className="text-center">No rides scheduled right now.</div>


      }

      {booking.length > 0 && (
        <div className="flex gap-6 justify-center">
          <button
            onClick={() => {
              handleLoadMores(filter);
            }}
            disabled={page == 0 ? true : false}
            className={` p-2 rounded-[8px] flex items-center ${page == 0
              ? "bg-[#58595B] text-white"
              : "text-white bg-[#ED1C24]"
              }`}
          >
            <BiChevronLeft />
          </button>
          <button
            onClick={() => {
              handleLoadMore(filter);
            }}
            disabled={page + 1 == bookingTotalPage ? true : false}
            className={` p-2 flex items-center rounded-[8px] ${page + 1 == bookingTotalPage
              ? "bg-[#58595B] text-white"
              : "text-white bg-[#ED1C24]"
              }`}
          >
            <BiChevronRight />
          </button>
        </div>
      )}
      {/* <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={bookingTotalRecords || 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      /> */}
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="cancel-booking-modal-title"
        aria-describedby="cancel-booking-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: isSmallScreen ? "90%" : 400, // Slightly smaller width for laptops
            bgcolor: "background.paper",
            padding: 3,
            boxShadow: 24,
            borderRadius: 2,
            overflow: "hidden",
          }}
          className="border-none"
        >
          <button className="absolute top-3 right-3" onClick={handleCloseModal}>
            <img src={clearIcon} className="cursor-pointer w-5 h-5" />
          </button>
          <Typography
            variant="h6"
            className="text-center text-base lg:text-lg font-semibold mb-3"
            id="cancel-booking-modal-title"
            sx={{ color: "#58595B" }}
          >
            Cancel Booking
          </Typography>

          <div
            className="text-center mb-5 text-sm md:text-base lg:text-lg"
            style={{ color: "#58595B" }}
          >
            Cancellation Reasons
          </div>

          <div className="space-y-3">
            {cancellationReasoning?.map((response: any, index: any) => (
              <div className="flex items-center" key={index} style={{ color: "#58595B" }}>
                <input
                  onChange={(value: any) => setOption(value.target.value)}
                  className="text-base md:text-lg lg:text-xl mr-2"
                  type="radio"
                  value={response.code}
                  name="cancellationReasoning"
                />
                <label className="text-xs md:text-sm lg:text-base">
                  {response.description}
                </label>
              </div>
            ))}
          </div>

          <Typography
            variant="body1"
            className="text-center mb-5 text-xs md:text-sm  mt-2"
            id="cancel-booking-modal-description"
            sx={{ color: "#58595B" }}
          >
            Are you sure you want to cancel this booking? This action cannot be undone.
          </Typography>

          <Stack direction="row" justifyContent="center" spacing={3}>
            <button
              onClick={handleCloseModal}
              className="bg-[#ED1C24] text-white px-3 py-1.5 md:px-5 md:py-2 lg:px-6 lg:py-2.5 rounded-full hover:bg-[#ED1C24] text-xs md:text-sm lg:text-base"
            >
              No, Go Back
            </button>

            <button
              onClick={() => {
                handleCloseModal();
              }}
              className="bg-[#ED1C24] text-white px-3 py-1.5 md:px-5 md:py-2 lg:px-6 lg:py-2.5 rounded-full hover:bg-[#ED1C24] text-xs md:text-sm lg:text-base"
            >
              Yes, Cancel
            </button>
          </Stack>
        </Box>
      </Modal>
    </div>
  );
};

export default BookingTable;
